// Pixel-art "1" rendered as SVG — each rect is one pixel cell
const PIXELS = [
  [0, 0], [1, 0],          // row 0: .██.
  [1, 1],                   // row 1: ..█.
  [1, 2],                   // row 2: ..█.
  [1, 3],                   // row 3: ..█.
  [0, 4], [1, 4], [2, 4],  // row 4: ███
];

const PixelLogo = ({ size = 24, color = '#0F172A' }) => {
  const cell = size / 3;   // 3 columns wide
  const h = cell * 5;      // 5 rows tall

  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 3 5"
      style={{ imageRendering: 'pixelated', display: 'block', flexShrink: 0 }}
      aria-hidden="true"
    >
      {PIXELS.map(([col, row], i) => (
        <rect key={i} x={col} y={row} width={1} height={1} fill={color} />
      ))}
    </svg>
  );
};

export default PixelLogo;
